import { render, staticRenderFns } from "./template.vue?vue&type=template&id=7f54181d&scoped=true&"
import script from "@/Components/Global/NotificationsButton/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/NotificationsButton/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/NotificationsButton/style.scss?vue&type=style&index=0&id=7f54181d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f54181d",
  null
  
)

export default component.exports